import React, { useMemo } from 'react'

import { Checkbox } from 'core-components/library/checkbox'
import { Dropdown } from 'core-components/library/dropdown'
import { Static } from 'core-components/types'
import { StorageApi } from 'src/core/classes/services/api/StorageApi'
import { Crud } from 'src/core/types/Crud'

export enum MY_CONNECT_LINE {
  africa = 'africa',
  france = 'france',
}

export interface IDialerSettings {
  isCallablePhoneNumbers: boolean
  line: MY_CONNECT_LINE
}

interface IProps {
  settings: IDialerSettings
  onChange: (settings: IDialerSettings) => void
}

export const getConnectLines = () => [
  { key: MY_CONNECT_LINE.africa, name: 'Africa/Capetown' },
  { key: MY_CONNECT_LINE.france, name: 'France/Frankfurt' },
]

export const getStaticCrudConnectLines = () =>
  new Crud({
    fetcher: new Static(getConnectLines()),
    keyField: 'key',
  })

export const setDialerSettings = async (dialerSettings: IDialerSettings) => {
  const settings = StorageApi.get('settings')
  if (settings) {
    settings.dialerSettings = settings.dialerSettings
      ? { ...settings.dialerSettings, ...dialerSettings }
      : dialerSettings
    await StorageApi.set('settings', settings)
  }
}

export const getDialerSettings = (): IDialerSettings => {
  const settings = StorageApi.get('settings')
  if (settings && settings.hasOwnProperty('dialerSettings')) {
    return settings.dialerSettings
  }
  return {} as IDialerSettings
}

export const DialerSettings = ({ settings, onChange }: IProps) => {
  const source = useMemo(() => getStaticCrudConnectLines(), [])

  return (
    <div>
      <Checkbox
        onChange={(flag: boolean) => onChange({ ...settings, isCallablePhoneNumbers: flag })}
        checked={settings.isCallablePhoneNumbers}
        margin={'sm'}
        label={'Callable phone numbers [MyConnect]'}
      />
      {settings.isCallablePhoneNumbers ? (
        <Dropdown
          label="Line"
          caption="name"
          source={source}
          value={settings.line}
          onChange={async (value: string) => {
            const inputValue = value as MY_CONNECT_LINE
            onChange({
              ...settings,
              line:
                inputValue && Object.values(MY_CONNECT_LINE).includes(inputValue)
                  ? inputValue
                  : MY_CONNECT_LINE.france,
            })
          }}
          margin={'sm'}
        />
      ) : null}
    </div>
  )
}
